import { cn } from "@/utils/cn";

interface Props {
  label: string;
  italicSuffix?: string;
  count?: number | string;
  className?: string;
}

export function SectionHead({ label, italicSuffix, count, className }: Props) {
  return (
    <div className={cn("flex items-baseline justify-between border-b border-ruleline pb-3", className)}>
      <h2 className="text-smallcaps">
        <span className="uppercase tracking-[0.16em] text-espresso-700">{label}</span>
        {italicSuffix ? (
          <span className="ml-2 font-serif italic normal-case tracking-normal text-warmgray-400">
            {italicSuffix}
          </span>
        ) : null}
      </h2>
      {count !== undefined ? (
        <span className="font-mono text-xs text-warmgray-400">{count} total</span>
      ) : null}
    </div>
  );
}
